﻿"use strict";

/* Definition for the durationAsStringFormatting validation rule */
if ($.validator && $.validator.unobtrusive) {
	$.validator.unobtrusive.adapters.add('durationAsStringFormatting', ['isTimeOfDay'], function (options) {
		options.rules['durationAsStringFormatting'] = {
			'isTimeOfDay': options.params['isTimeOfDay']
		};
		options.messages['durationAsStringFormatting'] = options.message;
	});

	$.validator.addMethod('durationAsStringFormatting', function (value, element, params) {
		value = value.replace(/\s$/, '');

		if (isNullOrWhiteSpace(value))
			return true;
		if (params['isTimeOfDay'] === 'False' && $(element).is(":focus")) {
			return true;
		}
		if (params['isTimeOfDay'] === 'True' && value.length < 4 && $(element).is(":focus")) {
			return true;
		}
		var valueInMinutes = timeDurationToMinutes(value, params['isTimeOfDay'] === 'False');

		if (isNaN(valueInMinutes))
			return true;

		$(element).val(valueInMinutes.toDurationString(true, false));

		return true;
	});
}

/* Definition for the durationAsStringGreaterThan validation rule */
if ($.validator && $.validator.unobtrusive) {
	$.validator.unobtrusive.adapters.add('durationAsStringGreaterThan', ['minValueInMinutes', 'allowEqualValues'], function (options) {
		options.rules['durationAsStringGreaterThan'] = {
			// Reading the parameters uses the case as in the parameter list of this function; setting the names is the same as used afterwards in $.validator.addMethod
			'minValueInMinutes': options.params['minValueInMinutes'],
			'allowEqualValues': options.params['allowEqualValues']
		};
		options.messages['durationAsStringGreaterThan'] = options.message;
	});
	$.validator.addMethod('durationAsStringGreaterThan', function (value, element, params) {
		var minValueInMinutes = params['minValueInMinutes'];
		if (isNullOrWhiteSpace(value) || isNullOrWhiteSpace(minValueInMinutes))
			return true;

		var valueInMinutes = timeDurationToMinutes(value, true);
		var minValueInMinutesInt = parseInt(minValueInMinutes);
		if (isNaN(valueInMinutes) || isNaN(minValueInMinutesInt))
			return true;
		return valueInMinutes > minValueInMinutes || (valueInMinutes === minValueInMinutes && params["allowEqualValues"] === 'True');
	});
}

/* Definition for the durationAsStringGreaterThanOther validation rule */
if ($.validator && $.validator.unobtrusive) {
	// Here parameter names can have a different case than when supplying them in GetClientValidationRules
	$.validator.unobtrusive.adapters.add('durationAsStringGreaterThanOther', ['otherPropertyName', 'allowEqualValues', 'evaluateWhenThisValueNull'], function (options) {
		options.rules['durationAsStringGreaterThanOther'] = {
			// Reading the parameters uses the case as in the parameter list of this function; setting the names is the same as used afterwards in $.validator.addMethod
			'otherPropertyName': options.params['otherPropertyName'],
			'allowEqualValues': options.params['allowEqualValues'],
			'evaluateWhenThisValueNull': options.params['evaluateWhenThisValueNull']
		};
		options.messages['durationAsStringGreaterThanOther'] = options.message;
	});
	$.validator.addMethod('durationAsStringGreaterThanOther', function (value, element, params) {
		var otherValue = $('#' + params["otherPropertyName"]).val();
		if (params["evaluateWhenThisValueNull"] === 'True' && isNullOrWhiteSpace(value)) {
			value = "0:00";
		}
		if (isNullOrWhiteSpace(value) || isNullOrWhiteSpace(otherValue))
			return true;

		var valueInMinutes = timeDurationToMinutes(value, true);
		var otherValueInMinutes = timeDurationToMinutes(otherValue, true);
		if (isNaN(valueInMinutes) || isNaN(otherValueInMinutes))
			return true;
		return valueInMinutes > otherValueInMinutes || (valueInMinutes === otherValueInMinutes && params["allowEqualValues"] === 'True');
	});
}

/* Definition for the DurationAsStringSmallerThanOtherAttribute validation rule */
if ($.validator && $.validator.unobtrusive) {
	// Here parameter names can have a different case than when supplying them in GetClientValidationRules
	$.validator.unobtrusive.adapters.add('durationAsStringSmallerThanOther', ['otherPropertyName', 'allowEqualValues'], function (options) {
		options.rules['durationAsStringSmallerThanOther'] = {
			// Reading the parameters uses the case as in the parameter list of this function; setting the names is the same as used afterwards in $.validator.addMethod
			'otherPropertyName': options.params['otherPropertyName'],
			'allowEqualValues': options.params['allowEqualValues']
		};
		options.messages['durationAsStringSmallerThanOther'] = options.message;
	});
	$.validator.addMethod('durationAsStringSmallerThanOther', function (value, element, params) {
		var otherValue = $('#' + params["otherPropertyName"]).val();

		if (isNullOrWhiteSpace(otherValue))
			otherValue = null;
		if (isNullOrWhiteSpace(value))
			value = null;
		var valueInMinutes = timeDurationToMinutes(value, true);
		var otherValueInMinutes = timeDurationToMinutes(otherValue, true);
		if (isNaN(valueInMinutes) || isNaN(otherValueInMinutes))
			return true;

		return valueInMinutes < otherValueInMinutes || (valueInMinutes === otherValueInMinutes && params["allowEqualValues"] === 'True');

	});
}

/* Definition for the ComputeDurationForOtherFromTotalThisAndMoreAttribute validation rule */
if ($.validator && $.validator.unobtrusive) {
	// Here parameter names can have a different case than when supplying them in GetClientValidationRules
	$.validator.unobtrusive.adapters.add('computeDurationForOtherFromTotalThisAndMore', ['otherPropertyName', 'totalPropertyName', 'propertyNames'], function (options) {
		options.rules['computeDurationForOtherFromTotalThisAndMore'] = {
			// Reading the parameters uses the case as in the parameter list of this function; setting the names is the same as used afterwards in $.validator.addMethod
			'otherPropertyName': options.params['otherPropertyName'],
			'totalPropertyName': options.params['totalPropertyName'],
			'propertyNames': options.params['propertyNames']
		};
		options.messages['computeDurationForOtherFromTotalThisAndMore'] = options.message;
	});
	$.validator.addMethod('computeDurationForOtherFromTotalThisAndMore', function (value, element, params) {

		var propertyNamesArray = JSON.parse(params["propertyNames"]);
		var allNull = true;
		for (var k = 0; k < propertyNamesArray.length; k++) {
			if (!isNullOrWhiteSpace($('#' + propertyNamesArray[i]).val())) {
				allNull = false;
				break;
			}
		}

		var totalValue = $('#' + params["totalPropertyName"]).val();
		if (isNullOrWhiteSpace(value)) {
			if (allNull && isNullOrWhiteSpace(totalValue) ) {
				$('#' + params["otherPropertyName"]).val(null);
				return true;
			} else {
				value = 0;
			}
		}

		if (isNullOrWhiteSpace(totalValue))
			totalValue = 0;

		if (totalValue === null)
			totalValue = 0;

		var totalValueInMinutes = timeDurationToMinutes(totalValue, true);
		var thisValueInMinutes = timeDurationToMinutes(value, true);

		var summedValueInMinutes = thisValueInMinutes;
		for (var i = 0; i < propertyNamesArray.length; i++) {
			var propertyValue = $('#' + propertyNamesArray[i]).val();
			if (isNullOrWhiteSpace(propertyValue))
				propertyValue = null;

			var propertyValueInMinutes = timeDurationToMinutes(propertyValue, true);
			if (isNaN(propertyValueInMinutes))
				propertyValueInMinutes = 0;

			summedValueInMinutes += propertyValueInMinutes;
		}
		if (totalValueInMinutes - summedValueInMinutes >= 0) {
			$('#' + params["otherPropertyName"]).val((totalValueInMinutes - summedValueInMinutes).toDurationString(true, false));
			return true;
		}
		return false;
	});
}
/* Definition for the ComputeIntegerFromTotalAndOtherAsStringAttribute validation rule */
if ($.validator && $.validator.unobtrusive) {
	// Here parameter names can have a different case than when supplying them in GetClientValidationRules
	$.validator.unobtrusive.adapters.add('computeIntegerForOtherFromTotalAndThis', ['otherPropertyName', 'totalPropertyName'], function (options) {
		options.rules['computeIntegerForOtherFromTotalAndThis'] = {
			// Reading the parameters uses the case as in the parameter list of this function; setting the names is the same as used afterwards in $.validator.addMethod
			'otherPropertyName': options.params['otherPropertyName'],
			'totalPropertyName': options.params['totalPropertyName']
		};
		options.messages['computeIntegerForOtherFromTotalAndThis'] = options.message;
	});
	$.validator.addMethod('computeIntegerForOtherFromTotalAndThis', function (value, element, params) {
		var totalValue = $('#' + params["totalPropertyName"]).val();

		if (isNullOrWhiteSpace(value)) {
			if (isNullOrWhiteSpace(totalValue)) {
				$('#' + params["otherPropertyName"]).val(null);
				return true;
			} else {
				value = 0;
			}
		}

		if (isNullOrWhiteSpace(value))
			value = 0;

		if (isNullOrWhiteSpace(totalValue))
			totalValue = 0;

		var totalValueInt = parseInt(totalValue);
		var thisValueInt = parseInt(value);
		if (isNaN(totalValueInt) || isNaN(thisValueInt))
			return true;

		if (totalValueInt - thisValueInt >= 0) {
			$('#' + params["otherPropertyName"]).val(totalValueInt - thisValueInt);
			return true;
		}
		return false;

	});
}
/* Definition for the IntegerSmallerThanOtherAttribute validation rule */
if ($.validator && $.validator.unobtrusive) {
	// Here parameter names can have a different case than when supplying them in GetClientValidationRules
	$.validator.unobtrusive.adapters.add('integerSmallerThanOther', ['otherPropertyName', 'allowEqualValues'], function (options) {
		options.rules['integerSmallerThanOther'] = {
			// Reading the parameters uses the case as in the parameter list of this function; setting the names is the same as used afterwards in $.validator.addMethod
			'otherPropertyName': options.params['otherPropertyName'],
			'allowEqualValues': options.params['allowEqualValues']
		};
		options.messages['integerSmallerThanOther'] = options.message;
	});
	$.validator.addMethod('integerSmallerThanOther', function (value, element, params) {
		var otherValue = $('#' + params["otherPropertyName"]).val();
		if (isNullOrWhiteSpace(otherValue))
			otherValue = 0;
		if (isNullOrWhiteSpace(value))
			value = 0;

		var valueInMinutes = parseInt(value);
		var otherValueInMinutes = parseInt(otherValue);
		if (isNaN(valueInMinutes) || isNaN(otherValueInMinutes))
			return true;

		return valueInMinutes < otherValueInMinutes || (valueInMinutes === otherValueInMinutes && params["allowEqualValues"] === 'True');
	});
}


/* Definition for the IntegerGreaterThanOtherAttribute validation rule */
if ($.validator && $.validator.unobtrusive) {
	// Here parameter names can have a different case than when supplying them in GetClientValidationRules
	$.validator.unobtrusive.adapters.add('integerGreaterThanOther', ['otherPropertyName', 'allowEqualValues'], function (options) {
		options.rules['integerGreaterThanOther'] = {
			// Reading the parameters uses the case as in the parameter list of this function; setting the names is the same as used afterwards in $.validator.addMethod
			'otherPropertyName': options.params['otherPropertyName'],
			'allowEqualValues': options.params['allowEqualValues']
		};
		options.messages['integerGreaterThanOther'] = options.message;
	});
	$.validator.addMethod('integerGreaterThanOther', function (value, element, params) {
		var otherValue = $('#' + params["otherPropertyName"]).val();
		if (isNullOrWhiteSpace(otherValue))
			otherValue = 0;
		if (isNullOrWhiteSpace(value))
			value = 0;

		var valueInMinutes = parseInt(value);
		var otherValueInMinutes = parseInt(otherValue);
		if (isNaN(valueInMinutes) || isNaN(otherValueInMinutes))
			return true;

		return valueInMinutes > otherValueInMinutes || (valueInMinutes === otherValueInMinutes && params["allowEqualValues"] === 'True');
	});
}
